var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31037 7.69458C8.0991 7.89014 7.81259 8 7.51384 8C7.2151 8 6.92859 7.89014 6.71731 7.69458L0.343948 1.79348C0.236343 1.69725 0.150514 1.58214 0.0914678 1.45487C0.0324221 1.32761 0.00134247 1.19072 4.25376e-05 1.05222C-0.00125739 0.913706 0.0272487 0.776345 0.0838968 0.648146C0.140545 0.519946 0.224201 0.403476 0.329984 0.305532C0.435766 0.207587 0.561557 0.13013 0.700016 0.0776796C0.838475 0.0252291 0.98683 -0.00116422 1.13642 3.93863e-05C1.28602 0.00124299 1.43385 0.0300196 1.57131 0.0846901C1.70876 0.139361 1.83308 0.21883 1.93701 0.318461L7.51384 5.48206L13.0907 0.318461C13.3032 0.128443 13.5878 0.0232993 13.8832 0.0256761C14.1786 0.0280528 14.4611 0.13776 14.67 0.331168C14.8789 0.524577 14.9974 0.786212 15 1.05972C15.0025 1.33323 14.889 1.59674 14.6837 1.79348L8.31037 7.69458Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrow);
export default __webpack_public_path__ + "static/media/orange-arrow.1f6c7134868ea39fc522331cdd2f371f.svg";
export { ForwardRef as ReactComponent };